<template>
  <div class="hpCollage">
    <div class="hpcTitle">
        <div class="hpSecTitle">{{localize('from_our_blog')}}</div>
    </div>
    
    <div class="hpSecSub">
      <router-link :to="getMainPageLink">
      {{localize('mis_news_and_articles')}} - <span>{{localize('view_all')}}</span>
      </router-link>
    </div>

    <!-- component of pro tips -->
    <div class="pt-2xl">

<!--         <div class="tmpScroller">
          <div class="tmpItems">
              <a class="tmpItem">1</a>
              <a class="tmpItem">2</a>
              <a class="tmpItem">3</a>
              <a class="tmpItem">4</a>
          </div>
        </div>
 -->
        <div class="colsScroller" ref="colsScrolledElements">
          <div class="colBoxes">
              <router-link :to="item.url"
                  v-for="(item,index) in pageData" 
                  :class="['reveal','cbox','colBox'+index]"                
                  :key="'colitem_'+index"
                  :style="getBoxStyle(item,index)">

                  <div class="boxImgMobile" :style="getBoxStyle(item,index)"></div>

                  <div class="boxOver">
                      <div class="text1 hpFont1">{{item.subtitle}}</div>
                      <div :class="['text2', index==0 ? 'hpFont2Extra':'hpFont2']">{{item.title}}</div>
                      <div class="textLink text1">
                        <span>{{localize('view')}}</span>
                        <span>{{localize('view')}}</span>
                      </div>
                  </div>


              </router-link>
          </div>
        </div>
    </div>

    <!--
    <div class="colsPager">
        <sidepager
            @item-change = "onPagerChange"
            :skinMode="0"
            :itemIndex="currentPage" 
            :itemsPerPage="1"
            :mobilePagesCount = "sectionData.items.length"
            :items="sectionData.items">
        </sidepager>
    </div>
    -->

<!--     <abtn style="float:right;" color="blue" :class="['self-end mt-xl']" mini>
      <span style="font-weight:400 !important;">More Tips</span>
    </abtn>    
 -->  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import hpAccordion from "./comp/hpAccordion.vue";
import sidepager from "@/views/com/sidepager.vue";

export default {
components: { hpAccordion,sidepager },
  props: {
    sectionData:{}
  },
  data() {
    return {
        itemsPerPage:1,
        currentPage:0,
        activeIndex: 0,
        ___pageData:
        [
          {
            "title":"IDS 2023: Introducing MIS XD!",
            "subtitle":"March, 2023",
            "url":"/blog/ids-2023",
            "img":"https://www.mis-implants.com/upload/Blog/MISBooth_xd.jpg"
          },
          {
            "title":"Revolution in a Box: How XD is Changing Implant Dentistry",
            "subtitle":"January, 2023",
            "url":"/blog/xd",
            "img":"https://www.mis-implants.com/upload/Blog/xd-blog.jpg"
          },
          {
            "title":"Europerio10: Simply Amazing!",
            "subtitle":"June, 2022",
            "url":"/blog/europerio10",
            "img":"https://www.mis-implants.com/upload/Blog/_60A9859.jpg"
          },
          {
            "title":"MDR Certification: A Springboard for Improved Patient Safety!",
            "subtitle":"April, 2022",
            "url":"/blog/mdr",
            "img":"https://www.mis-implants.com/upload/Blog/team.jpg"
          }
        ]
    };
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    ...mapGetters(["localeString"]),
    getMainPageLink()
    {
      return this.parsedLocaleString+"/blog";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
      return this.sectionData.items;
    }

  },
  methods: {
    onPagerChange(index)
    {
      this.navTo(index);
    },
    navTo(index)
    {
      var indexOfElement = index * this.itemsPerPage;
      let scrollToElement = this.$refs.colsScrolledElements.getElementsByClassName("cbox")[indexOfElement];
      scrollToElement.scrollIntoView(
      { 
          behavior: 'smooth',
          inline:'start',
          block:'nearest' }
      );      
    },      
    getBoxStyle(item,index)
    {
        var imgURL = "https://www.mis-implants.com/upload/Blog/xd-blog.jpg";
        //background-image: url("https://images.unsplash.com/photo-1534719156993-f3c9448673bf?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=f089cfa06eb1cd7c0f654b39d8fdfd07&auto=format&fit=crop&w=1350&q=80");
        return "--index:"+index+";background-image:url(https://www.mis-implants.com/upload/"+item.img+")";
    }
  }
};
</script>

<style scoped>
  .boxImgMobile
  {
    display: none;
  }
  /* animation start  */
  .cbox.reveal {
      opacity: 0;
      transition: all ease-in 0.8s;
      transition-delay: calc(var(--index) * 0.25s);
  }  
  .cbox.reveal.active {
      opacity: 1;
  }  

  .colsPager
  {
    display: none;
  }

.hpCollage
{
  padding-top: 0vw;
}
.hpcTitle
{
  padding-left:10vw;
  padding-right:10vw;

}
.colBoxes
{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 80vw;
  height: 40vw;
  grid-gap: 10px;
  margin: auto;
  /* perspective: 2px; */

}
.colBoxes .cbox
{
    background-color: #000;    
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;
    border-radius: 25px;

}
.colBox0
{
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  border-radius: 0 25px 25px 0;
  /* transform: translateZ(-2px); */
}
.colBox1
{
  grid-column-start: 3;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 2;
  border-radius: 25px;
}
.colBox2
{
  grid-column-start: 4;
  grid-column-end: 5;
  grid-row-start: 1;
  grid-row-end: 2;
  border-radius: 25px 0px 0px 25px;
}
.colBox3
{
  grid-column-start: 3;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 3;
  border-radius: 25px 0px 0px 25px;
}
.colBoxes .cbox .boxOver
{
    opacity: 0;
    transition: all ease 0.3s;
}
.boxOver
{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #0192e5;
    align-content: center;
    align-items: center;
    padding: 2vw;
}

.boxOver .text1
{
    color: #fff;
    clear: both;
    width: 100%;
    display: block;
    font-weight: 300 !important;
}
.boxOver .text2
{
    padding-top: 10px;
    padding-bottom: 30px;
    color: #fff;
    clear: both;
    width: 100%;
    display: block;
    font-weight: 500 !important;
}
.boxOver .text2.hpFont2Extra
{
  font-size: clamp(2rem, 2.5vw, 2.5rem) !important;
  line-height: clamp(2rem,3vw, 3rem) !important;
  letter-spacing: -1px !important;
}

.colBoxes .cbox:nth-child(1) .boxOver
{
    padding: 6vw;
}

.boxOver .textLink span
{
    color: #fff;
    font-weight: 500 !important;
    border-radius: 30px;
    padding: 10px 20px;
    border: solid 2px #fff;
}

.boxOver .textLink
{
  position: relative;
  cursor: pointer;  
}
.boxOver .textLink span:nth-child(2)
{
  position: absolute;
  background-color: #fff;
  color: #0192e5;
  top: -12px;
  left: 0px;
  clip-path: inset(100% 0 0 0);
  transition: all ease 0.4s;
}


  .cbox .xLine
  {
    line-height: 24px;
  }
  .cbox .xLineText
  {      
      transition-delay: calc(0.14s * var(--line_index)) !important;      
      transition:all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      /* transform: translateY(40px); */
      opacity: 1;         
  }
  .cbox .text1 .xLineText
  {
    font-weight: 300 !important;   
  }
  .cbox .text2 .xLineText
  {
    font-weight: 500 !important;   
  }

    @media (hover: hover) {
      .colBoxes .cbox:hover .boxOver
      {
          opacity: 1;
      }
      .boxOver .textLink:hover span:nth-child(2)
      {
        clip-path: inset(0 0 0 0);
      }
      .cbox:hover .xLineText
      {      
          /* transform: translateY(0);opacity: 1; */
      }
    }


    @media screen and (max-width: 815px) {

        .colsScroller
        {
            width: 100vw;
            overflow-x: scroll;
            overflow-y: hidden;
            scroll-snap-type: x mandatory;
            scroll-snap-align: center;
            -webkit-overflow-scrolling: touch;
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */    
            margin: auto;      
        }
        .hpCollage
        {
          /* padding-top: 9.5vw; */
          padding-top: 3vw;
          padding-bottom: 10vw;

        }   
        .cbox.reveal {
            opacity: 1 !important;
        }          
        .colBoxes
        {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
          margin: 0px;
          height: 140vw;          
          width: 336vw;
          /* gap: 10px; */        
          /* width: 344vw; */
          margin-right: 5vw;
          gap: 0px;
          
        }
        .cbox
        {
            scroll-snap-align:center;
            flex:1;
            background-size: 200%;
            background-position: top center;
            background-repeat: no-repeat;
            margin-left: 5vw;
        }
        .colsPager
        {
          padding-top:30px;
          display: block;
          width: 100px;
          margin: auto;
        }      


        .boxImgMobile
        {
          display: block;
          position: absolute;
          height: 60%;
          left: 0;
          top: 0;
          background-position: center;
          background-size: cover;
          width: 100%;          
        }
        .boxOver 
        {
          position: absolute;
          height: 40%;
          opacity: 1 !important;
          left: 0;
          padding: 6vw;
          bottom: 0;
        }

        .boxOver .text2.hpFont2,
        .boxOver .text2.hpFont2Extra
        {
            font-size: clamp(1.2rem, 1.4vw, 2.5rem) !important;
            line-height: clamp(1.4rem, 1.5vw, 2.5rem) !important;
            line-height: initial;            
        }



        .___colBoxes
        {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
          height: 100vw;
          grid-gap: 10px;
          width: 90vw;
          margin: auto;          
        }

        /*
        .colBox0
        {
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 1;
          grid-row-end: 2;          
          border-radius: 0px 0px 25px 0px;
        }
        .colBox1
        {
          grid-column-start: 2;
          grid-column-end: 3;
          grid-row-start: 1;
          grid-row-end: 2;     
          border-radius: 0px 0px 0px 25px;     
        }
        .colBox2
        {
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 2;
          grid-row-end: 3;          
          border-radius: 0px 25px 0px 0px;     
        }        
        .colBox3
        {
          grid-column-start: 2;
          grid-column-end: 3;
          grid-row-start: 2;
          grid-row-end: 3;    
          border-radius:25px 0px 0px 0px;           
        }      
        */  

    }  

</style>
